export default __webpack_public_path__ + "static/media/Diviner's Leggings of the Emissary.b04d229d.jpg";